<app-comments-form
  #form
  [headerHeight]="'3.5rem'"
  [comments]="comments$ | async"
  [isLoading]="isLoadingComments$ | async"
  [dropdownItems]="userDropdownItems$ | async"
  [visibilityTagLabel]="visibilityTagLabel$ | async"
  (filterText)="filterText($event)"
  (commentValueChanged)="onCommentValueChange($event)"
  (newComment)="newComment($event)" />
